import { render, staticRenderFns } from "./WorkTabsPicker.vue?vue&type=template&id=6a3cde9e&scoped=true"
import script from "./WorkTabsPicker.vue?vue&type=script&lang=js"
export * from "./WorkTabsPicker.vue?vue&type=script&lang=js"
import style0 from "./WorkTabsPicker.vue?vue&type=style&index=0&id=6a3cde9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3cde9e",
  null
  
)

export default component.exports